import Link from "next/link"
import styles from "./product-info.module.css"

export default function ProductList({ block }) {
  const { list } = block.attrs

  if (list.length === 0) {
    return null
  }

  return (
    <ol className="box-content px-4 mx-auto mt-7 max-w-1xl mb-7.5 sm:px-10">
      {list.map((item, index) => {
        return <ListItem key={`prodlist-${index}`} data={item} />
      })}
    </ol>
  )
}

const ListItem = ({ data }) => {
  return (
    <li
      className={`${styles.listItem} flex justify-between border-b border-black-100/20 py-5`}>
      <span className="text-xl font-bold">{data.label}</span>
      {data.type === "link" && data?.url && (
        <Link
          className="underline text-good-blue-100"
          href={data.url}
          prefetch={false}>
          {data.text}
        </Link>
      )}
      {data.type === "text" && (
        <span className="w-1/2 text-right">{data.text}</span>
      )}
    </li>
  )
}
